import { render, staticRenderFns } from "./CatalogList.vue?vue&type=template&id=3b116482&scoped=true"
import script from "./CatalogList.vue?vue&type=script&lang=js"
export * from "./CatalogList.vue?vue&type=script&lang=js"
import style0 from "./CatalogList.vue?vue&type=style&index=0&id=3b116482&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b116482",
  null
  
)

export default component.exports